import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import './style.scss'

export default class Button extends Component {
    static propTypes = {
        color: PropTypes.string,
        loading: PropTypes.bool,
        onClickHandler: PropTypes.func,
        text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        type: PropTypes.string.isRequired,
        id: PropTypes.string,
    }

    static defaultProps = {
        color: null,
        onClickHandler: () => {},
    }

    onClickHandler = () => {
        const { onClickHandler, type } = this.props

        onClickHandler(type)
    }

    render() {
        const { color, text, loading, name } = this.props

        return (
            <div className={cx('dialog-button', color, loading && 'loading')} onClick={this.onClickHandler} id={name}>
                {text}
            </div>
        )
    }
}
